module.exports = __webpack_public_path__ + "img/test_05.a0d26f06.png";